import { render, staticRenderFns } from "./NewsTableFilter.vue?vue&type=template&id=a54a68c0&"
import script from "./NewsTableFilter.vue?vue&type=script&lang=js&"
export * from "./NewsTableFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports